package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Place
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.CaracterizacaoOcorrencia
import br.com.htms.inspeccaocampo.data.ClasseEventoOcorrencia
import br.com.htms.inspeccaocampo.data.ErroCampo
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.TipoOcorrencia
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.PersonNameAutocompleteField
import br.com.htms.inspeccaocampo.shared.ui.components.PreviaAntesSalvarDialog
import br.com.htms.inspeccaocampo.shared.ui.components.SharedFotosMenu
import br.com.htms.inspeccaocampo.ui.FormPrevia
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.kit.OpcaoLista
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

private enum class SecaoOc(val rotulo: String, val icone: ImageVector, val campos: Set<String>) {
    OBRA("Obra e local", Icons.Filled.Place, setOf("cliente", "obra", "localGps")),
    CLASSIFICACAO("Classificação", Icons.Filled.List, setOf("caracterizacao", "tipo", "tipoEvento")),
    IDENTIFICACAO("Identificação", Icons.Filled.Info, setOf("dataHoraOcorrido", "localExato", "quemReportando")),
    PESSOAS(
        "Pessoas", Icons.Filled.Person,
        setOf("envolvidoNome", "envolvidoFuncao", "responsavelAtividade", "responsavelCargo", "responsavelEstavaNoLocal")
    ),
    DADOS(
        "Dados da ocorrência", Icons.Filled.Warning,
        setOf("dataAcidente", "horaAcidente", "horasTrabalhadas", "localAcidente", "parteCorpoLesionada", "agenteCausador", "naturezaLesao")
    ),
    DESCRICAO("Descrição", Icons.Filled.Edit, setOf("acoesTomadasImediato", "descricaoEvento")),
    FOTOS("Fotos", Icons.Filled.Star, setOf("fotos"))
}

@Composable
fun SharedComunicacaoOcorrenciasScreen(controller: AppController) {
    val form by controller.ocorrenciasForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()
    val appConfig by controller.appConfig.collectAsState()

    val snackbar = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var mostrarListaFotos by remember { mutableStateOf(false) }
    var mostrarPrevia by remember { mutableStateOf(false) }

    fun rotulo(id: String, padrao: String) = appConfig.rotuloOcorrencia(id, padrao)
    fun ativo(id: String) = appConfig.ocorrenciaAtiva(id)
    fun erro(id: String) = controller.erroNoCampo(id) != null
    fun up(f: (br.com.htms.inspeccaocampo.data.FormComunicacaoOcorrencias) -> br.com.htms.inspeccaocampo.data.FormComunicacaoOcorrencias) =
        controller.atualizarOcorrencias(f)

    val secoes = SecaoOc.entries.filter { s ->
        when (s) {
            SecaoOc.OBRA -> true
            SecaoOc.CLASSIFICACAO -> ativo("caracterizacao") || ativo("tipo") || ativo("tipoEvento")
            SecaoOc.IDENTIFICACAO -> ativo("dataHoraOcorrido") || ativo("localExato") || ativo("quemReportando")
            SecaoOc.PESSOAS -> ativo("envolvido") || ativo("responsavel")
            SecaoOc.DADOS -> ativo("dadosAcidente")
            SecaoOc.DESCRICAO -> ativo("acoesTomadasImediato") || ativo("descricaoEvento")
            SecaoOc.FOTOS -> ativo("fotos")
        }
    }
    val temErros = erros.isNotEmpty()
    val deslocamento = if (temErros) 1 else 0
    val secaoAtual by remember(secoes, deslocamento) {
        derivedStateOf { secoes.getOrNull((listState.firstVisibleItemIndex - deslocamento).coerceIn(0, secoes.lastIndex)) }
    }

    fun irPara(s: SecaoOc) {
        val i = secoes.indexOf(s)
        if (i >= 0) scope.launch { listState.animateScrollToItem(i + deslocamento) }
    }
    fun secaoDoErro(e: ErroCampo) = secoes.firstOrNull { e.campo in it.campos }

    LaunchedEffect(Unit) { controller.carregarObrasAtivas() }

    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    LaunchedEffect(erros) {
        if (erros.isEmpty()) return@LaunchedEffect
        runCatching { listState.animateScrollToItem(0) }
    }

    val itensMenu = secoes.map { s ->
        PortalMenuItem(s.name, s.rotulo, s.icone, destaque = erros.any { it.campo in s.campos })
    }

    Box(Modifier.fillMaxSize()) {
        PortalModulo(
            titulo = "Comunicação Prévia de ocorrências",
            itens = itensMenu,
            selecionado = secaoAtual?.name ?: "",
            onSelect = { irPara(SecaoOc.valueOf(it)) },
            rolavel = false,
            extraCabecalho = {
                PortalButton(onClick = { mostrarPrevia = true }) { Text("Prévia e salvar") }
            }
        ) { largo ->
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(listState, Modifier.fillMaxWidth().weight(1f)) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(bottom = 24.dp),
                verticalArrangement = Arrangement.spacedBy(18.dp)
            ) {
                if (temErros) {
                    item(key = "erros") {
                        Column(
                            Modifier
                            .fillMaxWidth()
                                .background(PortalCores.Vermelho.copy(alpha = 0.08f), RoundedCornerShape(14.dp))
                                .padding(16.dp),
                            verticalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            Text("Corrija os campos obrigatórios:", color = PortalCores.Vermelho, fontWeight = FontWeight.Bold)
                            erros.take(8).forEach { e ->
                        Text(
                                    "• ${e.mensagem}",
                                    color = PortalCores.Texto,
                                    textDecoration = TextDecoration.Underline,
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .clickable { secaoDoErro(e)?.let { irPara(it) } }
                                        .padding(vertical = 3.dp)
                                )
                            }
                            if (erros.size > 8) Text("... e mais ${erros.size - 8}", color = PortalCores.CinzaTexto)
                        }
                    }
                }
                secoes.forEach { s ->
                    item(key = s.name) {
                        when (s) {
                            SecaoOc.OBRA -> CartaoSecao("Obra e local", subtitulo = "Acidentes, incidentes e quase acidentes") {
                                if (ativo("cliente") || ativo("obra")) {
                                    val opObras = (obrasAtivas.map { it.nome } + form.obra).filter { it.isNotBlank() }.distinct().map { it to it }
                                    Par(
                                        largo,
                                        { m ->
                                            if (ativo("cliente")) {
                                                CampoOc("${rotulo("cliente", "Cliente")} *", form.cliente, erro("cliente"), m) { v -> up { it.copy(cliente = v) } }
                                            }
                                        },
                                        { m ->
                                            if (ativo("obra")) {
                                                Column(m) {
                                                    Seletor("${rotulo("obra", "Nome da obra")} *", opObras, form.obra, { v -> up { it.copy(obra = v) } })
                                                    if (erro("obra")) ErroTexto(controller.erroNoCampo("obra"))
                                                }
                                            }
                                        }
                                    )
                                }
                                val coords = if (form.latitude != null && form.longitude != null) "Lat: ${form.latitude}  Lng: ${form.longitude}" else ""
                                Row(
                                    Modifier.fillMaxWidth(),
                                    horizontalArrangement = Arrangement.spacedBy(10.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Column(Modifier.weight(1f)) {
                                        AppOutlinedTextField(
                                value = form.localTexto.ifBlank { "Aguardando GPS..." },
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Local (GPS)") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                            isError = erro("localGps")
                                        )
                                        if (coords.isNotBlank()) {
                                            Text(coords, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                                        }
                                    }
                                    if (largo) BotaoGps(controller, capturandoGps, Modifier)
                                }
                                if (!largo) BotaoGps(controller, capturandoGps, Modifier.fillMaxWidth())
                            }

                            SecaoOc.CLASSIFICACAO -> CartaoSecao("Classificação", subtitulo = "Marque uma opção em cada grupo.") {
                                val grupos = buildList<@Composable (Modifier) -> Unit> {
                                    if (ativo("caracterizacao")) add { m ->
                                        GrupoOpcoes(m, "${rotulo("caracterizacao", "Caracterização")} *", controller.erroNoCampo("caracterizacao")) {
                                            CaracterizacaoOcorrencia.entries.forEach { op ->
                                                OpcaoLista(op.rotulo, form.caracterizacao == op, { up { it.copy(caracterizacao = op) } })
                                            }
                                        }
                                    }
                                    if (ativo("tipo")) add { m ->
                                        GrupoOpcoes(m, "${rotulo("tipo", "Tipo")} *", controller.erroNoCampo("tipo")) {
                                            TipoOcorrencia.entries.forEach { op ->
                                                OpcaoLista(op.rotulo, form.tipo == op, { up { it.copy(tipo = op) } })
                                            }
                                        }
                                    }
                                    if (ativo("tipoEvento")) add { m ->
                                        GrupoOpcoes(m, "${rotulo("tipoEvento", "Tipo de evento")} *", controller.erroNoCampo("tipoEvento")) {
                                            ClasseEventoOcorrencia.entries.forEach { op ->
                                                OpcaoLista(op.rotulo, form.tipoEvento == op, { up { it.copy(tipoEvento = op) } })
                                            }
                                        }
                                    }
                                }
                                if (largo) {
                                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                        grupos.forEach { g -> g(Modifier.weight(1f)) }
                                    }
                                } else {
                                    grupos.forEach { g -> g(Modifier.fillMaxWidth()) }
                                }
                            }

                            SecaoOc.IDENTIFICACAO -> CartaoSecao("Identificação do evento") {
                                Par(
                                    largo,
                                    { m ->
                                        if (ativo("dataHoraOcorrido")) {
                                            AppDateTextField(
                                                value = form.dataHoraOcorrido,
                                                onValueChange = { v -> up { it.copy(dataHoraOcorrido = v) } },
                                                label = "${rotulo("dataHoraOcorrido", "Data e hora do ocorrido")} *",
                                                modifier = m,
                                                kind = DateFieldKind.DATE_TIME,
                                                isError = erro("dataHoraOcorrido")
                                            )
                                        }
                                    },
                                    { m ->
                                        if (ativo("quemReportando")) {
                                            PersonNameAutocompleteField(
                                                value = form.quemReportando,
                                                onValueChange = { v -> up { it.copy(quemReportando = v) } },
                                                label = "${rotulo("quemReportando", "Quem está reportando")} *",
                                                modifier = m,
                                                isError = erro("quemReportando"),
                                                formTipo = FormTipo.COMUNICACAO_OCORRENCIAS,
                                                appConfig = appConfig
                                            )
                                        }
                                    }
                                )
                                if (ativo("localExato")) {
                                    CampoOc(
                                        "${rotulo("localExato", "Local exato (setor/frente de serviço)")} *",
                                        form.localExato, erro("localExato"), Modifier.fillMaxWidth(), linhas = 2
                                    ) { v -> up { it.copy(localExato = v) } }
                                }
                            }

                            SecaoOc.PESSOAS -> {
                                val blocos = buildList<@Composable (Modifier) -> Unit> {
                                    if (ativo("envolvido")) add { m ->
                                        CartaoSecao(rotulo("envolvido", "Dados do envolvido"), modifier = m) {
                                            CampoOc("Nome *", form.envolvidoNome, erro("envolvidoNome")) { v -> up { it.copy(envolvidoNome = v) } }
                                            CampoOc("Função *", form.envolvidoFuncao, erro("envolvidoFuncao")) { v -> up { it.copy(envolvidoFuncao = v) } }
                                        }
                                    }
                                    if (ativo("responsavel")) add { m ->
                                        CartaoSecao(rotulo("responsavel", "Responsável pela atividade"), modifier = m) {
                                            CampoOc("Responsável pela atividade *", form.responsavelAtividade, erro("responsavelAtividade")) { v ->
                                                up { it.copy(responsavelAtividade = v) }
                                            }
                                            CampoOc("Cargo *", form.responsavelCargo, erro("responsavelCargo")) { v -> up { it.copy(responsavelCargo = v) } }
                                            Text("Estava no local *", color = PortalCores.Navy, fontWeight = FontWeight.SemiBold)
                                            LinhaOpcoes(
                                                opcoes = RespostaSimNao.entries,
                                                selecionada = form.responsavelEstavaNoLocal,
                                                rotulo = { it.rotulo },
                                                cor = { PortalCores.AzulIcone },
                                                onSelect = { op -> up { it.copy(responsavelEstavaNoLocal = op) } }
                                            )
                                            ErroTexto(controller.erroNoCampo("responsavelEstavaNoLocal"))
                                        }
                                    }
                                }
                                if (largo && blocos.size == 2) {
                                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                                        blocos.forEach { b -> b(Modifier.weight(1f)) }
                                    }
                                } else {
                                    Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                                        blocos.forEach { b -> b(Modifier.fillMaxWidth()) }
                                    }
                                }
                            }

                            SecaoOc.DADOS -> CartaoSecao(rotulo("dadosAcidente", "Dados da ocorrência")) {
                                Par(
                                    largo,
                                    { m ->
                                        Row(m, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                                            AppDateTextField(
                                                value = form.dataAcidente,
                                                onValueChange = { v -> up { it.copy(dataAcidente = v) } },
                                                label = "Data do acidente *",
                                                modifier = Modifier.weight(1f),
                                                kind = DateFieldKind.DATE,
                                                isError = erro("dataAcidente")
                                            )
                                            AppDateTextField(
                                                value = form.horaAcidente,
                                                onValueChange = { v -> up { it.copy(horaAcidente = v) } },
                                                label = "Hora do acidente *",
                                                modifier = Modifier.weight(1f),
                                                kind = DateFieldKind.TIME,
                                                isError = erro("horaAcidente")
                                            )
                                        }
                                    },
                                    { m -> CampoOc("Horas trabalhadas *", form.horasTrabalhadas, erro("horasTrabalhadas"), m) { v -> up { it.copy(horasTrabalhadas = v) } } }
                                )
                                Par(
                                    largo,
                                    { m -> CampoOc("Local do acidente *", form.localAcidente, erro("localAcidente"), m) { v -> up { it.copy(localAcidente = v) } } },
                                    { m -> CampoOc("Parte do corpo lesionada *", form.parteCorpoLesionada, erro("parteCorpoLesionada"), m) { v -> up { it.copy(parteCorpoLesionada = v) } } }
                                )
                                Par(
                                    largo,
                                    { m -> CampoOc("Agente causador da lesão *", form.agenteCausador, erro("agenteCausador"), m) { v -> up { it.copy(agenteCausador = v) } } },
                                    { m -> CampoOc("Natureza da lesão *", form.naturezaLesao, erro("naturezaLesao"), m) { v -> up { it.copy(naturezaLesao = v) } } }
                                )
                            }

                            SecaoOc.DESCRICAO -> CartaoSecao("Descrição") {
                                if (ativo("acoesTomadasImediato")) {
                                    CampoOc(
                                        "${rotulo("acoesTomadasImediato", "Ações tomadas de imediato")} *",
                                        form.acoesTomadasImediato, erro("acoesTomadasImediato"), Modifier.fillMaxWidth(), linhas = 3
                                    ) { v -> up { it.copy(acoesTomadasImediato = v) } }
                                }
                                if (ativo("descricaoEvento")) {
                                    CampoOc(
                                        "${rotulo("descricaoEvento", "Descrição do evento")} *",
                                        form.descricaoEvento, erro("descricaoEvento"), Modifier.fillMaxWidth(), linhas = 4
                                    ) { v -> up { it.copy(descricaoEvento = v) } }
                                }
                            }

                            SecaoOc.FOTOS -> CartaoSecao(
                                "${rotulo("fotos", "Fotos")} *",
                                subtitulo = "${form.fotos.size} foto(s) anexada(s)"
                            ) {
                            CampoFotoRow(
                                    label = "Câmera",
                                obrigatorio = true,
                                quantidadeFotos = form.fotos.size,
                                onTirarFoto = { controller.adicionarFotoOcorrencias() },
                                onAdicionarMais = { controller.adicionarFotoOcorrencias() },
                                    onAbrirLista = { mostrarListaFotos = true },
                                    onGaleria = { controller.adicionarFotoOcorrencias(fromGallery = true) }
                                )
                                ErroTexto(controller.erroNoCampo("fotos"))
                            }
                        }
                    }
                }
                item(key = "salvar") {
                    PortalButton(onClick = { mostrarPrevia = true }, modifier = Modifier.fillMaxWidth()) {
                        Text("Prévia e salvar")
                    }
                }
            }
            }
        }
        SnackbarHost(snackbar, Modifier.align(Alignment.BottomCenter).padding(16.dp))
    }

    if (mostrarPrevia) {
        PreviaAntesSalvarDialog(
            linhas = FormPrevia.ocorrencias(form),
            onConfirmar = { controller.validarESalvarOcorrencias() },
            onDismiss = { mostrarPrevia = false }
        )
    }

    if (mostrarListaFotos) {
        SharedFotosMenu(
            titulo = "Fotos da ocorrência",
            fotos = form.fotos,
            aberto = true,
            onFechar = { mostrarListaFotos = false },
            onRemover = { controller.removerFotoOcorrencias(it) }
        )
    }
}

@Composable
private fun CampoOc(
    label: String,
    valor: String,
    erro: Boolean,
    modifier: Modifier = Modifier.fillMaxWidth(),
    linhas: Int = 1,
    onChange: (String) -> Unit
) {
    AppOutlinedTextField(
        value = valor,
        onValueChange = onChange,
        label = { Text(label) },
        singleLine = linhas == 1,
        minLines = linhas,
        modifier = modifier,
        colors = FormFieldDefaults.textFieldColors(),
        isError = erro
    )
}

@Composable
private fun ErroTexto(msg: String?) {
    if (msg != null) Text(msg, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
}

@Composable
private fun BotaoGps(controller: AppController, capturando: Boolean, modifier: Modifier) {
    PortalOutlinedButton(onClick = { controller.capturarGpsOcorrencias() }, enabled = !capturando, modifier = modifier) {
        ButtonLoadingContent(loading = capturando, loadingText = "Capturando GPS...", idleText = "Atualizar local por GPS")
    }
}

@Composable
private fun GrupoOpcoes(modifier: Modifier, titulo: String, erro: String?, content: @Composable () -> Unit) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(titulo, color = PortalCores.Navy, fontWeight = FontWeight.Bold)
        content()
        ErroTexto(erro)
    }
}
